import {
  req,
  withParams
} from 'vuelidate/lib/validators/common';
import moment from 'moment';
import {
  dateFormat,
  dateRegex
} from '@/constants';

export default (value) => {
  return !req(value) || moment(value, dateFormat).isValid() && dateRegex.test(value);
};

const beforeDate = compareDate => withParams(
  {type: 'beforeDate', compareDate},
  (value) => {
    const compareDateValid = moment(compareDate, dateFormat).isValid() && dateRegex.test(compareDate),
      dateValid = moment(value, dateFormat).isValid() && dateRegex.test(value);
    return !req(value) || !compareDateValid || !dateValid || moment(value, dateFormat).isBefore(moment(compareDate, dateFormat), 'day');
  }
);

const sameOrBeforeDate = compareDate => withParams(
  {type: 'sameOrBeforeDate', compareDate},
  (value) => {
    const compareDateValid = moment(compareDate, dateFormat).isValid() && dateRegex.test(compareDate),
      dateValid = moment(value, dateFormat).isValid() && dateRegex.test(value);
    return !req(value) || !compareDateValid || !dateValid || moment(value, dateFormat).isSameOrBefore(moment(compareDate, dateFormat), 'day');
  }
);

const afterDate = compareDate => withParams(
  {type: 'afterDate', compareDate},
  (value) => {
    const compareDateValid = moment(compareDate, dateFormat).isValid() && dateRegex.test(compareDate),
      dateValid = moment(value, dateFormat).isValid() && dateRegex.test(value);
    return !req(value) || !compareDateValid || !dateValid || moment(value, dateFormat).isAfter(moment(compareDate, dateFormat), 'day');
  }
);

const sameOrAfterDate = compareDate => withParams(
  {type: 'sameOrAfterDate', compareDate},
  (value) => {
    const compareDateValid = moment(compareDate, dateFormat).isValid() && dateRegex.test(compareDate),
      dateValid = moment(value, dateFormat).isValid() && dateRegex.test(value);
    return !req(value) || !compareDateValid || !dateValid || moment(value, dateFormat).isSameOrAfter(moment(compareDate, dateFormat), 'day');
  }
);

export {
  beforeDate,
  sameOrBeforeDate,
  afterDate,
  sameOrAfterDate
};